<template>
  <div ref="app" data-app>
    <!-- <TestModuleComponent
      v-if="currentModule === 'TestModule'"
      ref="TestModule"
    /> -->

    <ExpenseSheetsModuleComponent
      v-if="currentModule === 'ExpenseSheetsModule'"
      ref="ExpenseSheetsModule"
    />

    <ExpenseSheetDetailDialogComponent
      v-if="currentModule === 'ExpenseSheetDetailDialog'"
      ref="ExpenseSheetDetailDialog"
    />

    <ProjectsModuleComponent
      v-if="currentModule === 'ProjectsModule'"
      ref="ProjectsModule"
    />

    <EmployeeCalendarComponent
      v-if="currentModule === 'EmployeeCalendar'"
      ref="EmployeeCalendar"
    />

    <!-- <DialogManagerComponent ref="DialogManager" @refresh="refreshModule" /> -->
  </div>
</template>
<script setup lang="ts">
import moment from "moment";
import { nextTick, onMounted, ref, type ComponentPublicInstance } from "vue";
import { useI18n } from "vue-i18n";
import { usePrimeVueLocale } from "./composables/usePrimeVueLocale";
// import TestModuleComponent from "./components/modules/TestModule.vue";
import ProjectsModuleComponent from "./components/modules/projects/ProjectsModule.vue";
import ExpenseSheetsModuleComponent from "./components/modules/expensesheets/ExpenseSheetsModule.vue";
import ExpenseSheetDetailDialogComponent from "./components/modules/expensesheets/ExpenseSheetDetailDialog.vue";
import EmployeeCalendarComponent from "./components/modules/employeecalendar/EmployeeCalendar.vue";
// import DialogManagerComponent from './components/modules/DialogManager.vue'

const { locale } = useI18n();

// Sincronizar locale de PrimeVue con i18n
usePrimeVueLocale();

const currentModule = ref<string>("TestModule");
const app = ref<HTMLElement | null>(null);

const TestModule = ref<ComponentPublicInstance | null>(null);
const ProjectsModule = ref<ComponentPublicInstance | null>(null);
const ExpenseSheetsModule = ref<ComponentPublicInstance | null>(null);
const ExpenseSheetDetailDialog = ref<ComponentPublicInstance | null>(null);
const EmployeeCalendar = ref<ComponentPublicInstance | null>(null);
// const DialogManager = ref<ComponentPublicInstance | null>(null);

// Mapa de referencias de módulos por nombre
const moduleRefs = {
  TestModule,
  ProjectsModule,
  ExpenseSheetsModule,
  ExpenseSheetDetailDialog,
  EmployeeCalendar,
  // DialogManager,
};

function applyLocale(newLocale: string): void {
  locale.value = newLocale;
  moment.locale(newLocale);
  // console.log(`🌐 Idioma cambiado a ${newLocale}`);
}

function getCurrentModule(): string {
  return currentModule.value;
}

function refreshModule(): void {
  const moduleName = currentModule.value;
  const moduleRef = (moduleRefs as any)[moduleName]?.value;

  if (moduleRef && typeof moduleRef.refreshModule === "function") {
    moduleRef.refreshModule();
    // console.log(`🔄 Módulo ${moduleName} refrescado`);
  } else {
    console.warn(`⚠️ El módulo ${moduleName} no tiene método refreshModule()`);
  }
}

function showModule(module: string, payload?: any): void {
  currentModule.value = module;


  nextTick(() => {
    nextTick(() => {
      const moduleRef = (moduleRefs as any)[module]?.value;

      if (moduleRef && typeof moduleRef.onReveal === "function") {
        moduleRef.onReveal(payload);
      }

      // Mostrar el wrapper de Vue si estaba oculto
      if (window.$vueWrapper) {
        window.$vueWrapper.style.display = "block";
      }
    });
  });
}

onMounted(() => {
  // Exponer VueBridge INMEDIATAMENTE (antes de nextTick)
  window.$vueBridge = {
    applyLocale,
    getCurrentModule,
    refreshModule,
    showModule,
  };

  // console.log("✅ App.vue montado, VueBridge expuesto a GWT");
  // console.log("🔍 window.$vueBridge disponible:", typeof window.$vueBridge);
  // console.log("🔍 Métodos disponibles:", Object.keys(window.$vueBridge));

  nextTick(() => {
    // Ajustar altura mínima del contenedor
    if (app.value) {
      const firstChild = app.value.firstElementChild as HTMLElement;
      if (firstChild) {
        firstChild.style.minHeight = "100%";
      }
    }
  });
});
</script>

<style>
/* Estilos globales para la aplicación */
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  width: 100%;
}

/* Asegurar que el contenedor raíz de Vue ocupe todo el espacio */
[data-app] {
  position: relative;
  width: 100% !important;
  min-height: 100% !important;
  height: 100% !important;
  display: block;
}

/* Asegurar que los módulos hijos también ocupen 100% */
[data-app] > * {
  width: 100%;
  min-height: 100%;
}
</style>
